import React from 'react'
import { CobuText, CobuView } from '@cobu/ui'
import { Strings } from '../../constants/Strings';

type ProfileVersionInfoProps = {
  appVersion?: string | null
  appBuildVersion?: string | null
}

export default function ProfileVersionInfo({ appVersion, appBuildVersion }: ProfileVersionInfoProps) {
  const strings = Strings.get();
  if (!appVersion && !appBuildVersion) return null
  return (
    <CobuView backgroundColor="$background" padding="$3">
      <CobuView alignItems="center">
        {appVersion ? (
          <CobuText color="$colorMuted">{`${strings.profile.components.profileVersionInfo.appVersion}${appVersion}`}</CobuText>
        ) : null}
        {/* {appBuildVersion ? (
          <CobuText color="$colorMuted">{`${strings.profile.components.profileVersionInfo.bundleVersion}: ${appBuildVersion}`}</CobuText>
        ) : null} */}
      </CobuView>
    </CobuView>
  )
}


